import ReactDOM from 'react-dom'
import React from 'react';
import AppComponent from './app/appComponent';
import {HashRouter as Router} from 'react-router-dom'
import './app.scss';
import './globalAppStyles.scss';
import './globalThemeStyles.scss';

ReactDOM.render(
    <Router>
        <AppComponent/>
    </Router>,
    document.getElementById('root')
);